// Helper function to parse emoji shortcodes
export const parseEmojis = (text) => {
  if (!text) return '';
  
  const emojiMap = {
    ':small_blue_diamond:': '🔹',
    ':large_blue_diamond:': '🔷',
    ':small_orange_diamond:': '🔸',
    ':large_orange_diamond:': '🔶',
    ':white_check_mark:': '✅',
    ':x:': '❌',
    ':heavy_check_mark:': '✔️',
    ':star:': '⭐',
    ':rocket:': '🚀',
    ':fire:': '🔥',
    ':warning:': '⚠️',
    ':information_source:': 'ℹ️',
    ':bulb:': '💡',
    ':gear:': '⚙️',
    ':wrench:': '🔧',
    ':hammer:': '🔨',
    ':package:': '📦',
    ':clipboard:': '📋',
    ':pencil:': '✏️',
    ':memo:': '📝',
    ':computer:': '💻',
    ':keyboard:': '⚙️',
    ':mouse:': '🖱️',
    ':paintbrush:': '🖌️',
    ':art:': '🎨',
    ':camera:': '📷',
    ':video_camera:': '📹',
    ':movie_camera:': '🎥',
    ':microphone:': '🎤',
    ':headphones:': '🎧',
    ':musical_note:': '🎵',
    ':game_die:': '🎲',
    ':dart:': '🎯',
    ':trophy:': '🏆',
    ':medal:': '🏅',
    ':1st_place_medal:': '🥇',
    ':2nd_place_medal:': '🥈',
    ':3rd_place_medal:': '🥉',
    ':chart_with_upwards_trend:': '📈',
    ':chart_with_downwards_trend:': '📉',
    ':bar_chart:': '📊',
    ':calendar:': '📅',
    ':date:': '📆',
    ':pushpin:': '📌',
    ':round_pushpin:': '📍',
    ':paperclip:': '📎',
    ':link:': '🔗',
    ':email:': '📧',
    ':envelope:': '✉️',
    ':inbox_tray:': '📥',
    ':outbox_tray:': '📤',
    ':lock:': '🔒',
    ':unlock:': '🔓',
    ':key:': '🔑',
    ':shield:': '🛡️',
    ':mag:': '🔍',
    ':mag_right:': '🔎',
    ':bell:': '🔔',
    ':loudspeaker:': '📢',
    ':mega:': '📣'
  };

  let result = text;
  Object.keys(emojiMap).forEach(key => {
    result = result.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), emojiMap[key]);
  });
  
  return result;
};
